import { ReactNode } from 'react';
import { tv } from '../utils/tv';
import { useMediaQuery } from '../utils/media-query';

const style = tv({
  base: `
    relative
    grid
    h-full
    grid-cols-1
    grid-rows-[auto,1fr,auto]
    overflow-hidden

    print:overflow-visible
  `,
  slots: {
    content: `
      overflow-y-auto
      overflow-x-hidden
      pb-xl
    `
  },
  variants: {
    withPadding: {
      true: { content: 'py-s' }
    },
    mobile: {
      true: {
        content: 'pt-xl'
      }
    }
  }
});

type Props = {
  header: ReactNode;
  content: ReactNode;
  bottom?: ReactNode;
  modal?: ReactNode;
  noContentPadding?: boolean;
};

export const LayoutPage = ({
  header,
  content,
  bottom,
  modal,
  noContentPadding
}: Props) => {
  const { desktopUp } = useMediaQuery();
  const { base, content: contentStyle } = style();
  return (
    <div className={base()}>
      <header>{header}</header>
      <main
        className={contentStyle({
          withPadding: !noContentPadding,
          mobile: !desktopUp
        })}
      >
        {content}
      </main>
      {bottom && <nav>{bottom}</nav>}
      {modal}
    </div>
  );
};
